<template>
  <div>
    <Modal :title="title" v-model="visible" width="815" class="my-modal top" :mask-closable="false" :footer-hide="true" @on-visible-change='changeVisible'>
      <Form ref="form" v-if="visible" :model="formData" class="page-form" :label-width="formData.type == 6?140:100">
        <FormItem prop="name" key="name" label="姓名" class="half">
          <span>{{ name }}</span>
        </FormItem>
        <FormItem prop="staffNo" key="staffNo" label="工号" class="half">
          <span>{{ staffNo }}</span>
        </FormItem>
        <template v-if="formData.type == 1 || formData.type == 4">
          <FormItem prop="rankName" key="rankName" label="当前职级" class="half">
            {{ rankName || '-' }}
          </FormItem>
          <FormItem prop="newRankId" key="newRankId" label="变更后职级" class="half" :rules="$units.formRule.required('请选择变更职级')">
            <Select v-model="formData.newRankId" filterable transfer>
              <Option v-for="(bean, i) in rankList" :key="i" :value="bean.id" v-if="formData.oldRankId != bean.id">{{ bean.name }} </Option>
            </Select>
          </FormItem>
          <FormItem v-if="formData.groupLeader === '0' && formData.type == 1" key="isChange" prop="isChange" label="是否迁移" class="full flex">
            <RadioGroup v-model="formData.isChange" @on-change="changeGroup">
              <Radio label="1">是</Radio>
              <Radio label="0">否</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem v-if="formData.isChange == 1" key="organizationName" prop="organizationName" label="迁移前团队" class="half">
            {{ formData.organizationName || '-' }}/{{ formData.groupName || '-' }}
          </FormItem>
          <FormItem v-if="formData.isChange == 1" key="isGroupLeader" prop="isGroupLeader" label="是否设为迁移后团队的队长" class="half">
            <RadioGroup v-model="formData.isGroupLeader">
              <Radio label="1">是</Radio>
              <Radio label="0">否</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem
            v-if="formData.isChange == 1"
            key="newGroupId"
            prop="newGroupId"
            label="迁移后团队"
            class="full flex"
            :rules="$units.formRule.required('请选择迁移后团队')"
          >
            <selectTree type="2" v-model="formData.newGroupId" @change="selectTreeChange" style="width:243px;" ref="selectTree"></selectTree>
            <span class="btn-add" @click="$refs.addTeam.open(formData, detail)">新建团队</span>
          </FormItem>
        </template>
        <template v-if="formData.type == 3">
          <FormItem prop="organizationName" key="organizationName" label="迁移前团队" class="half">
            {{ formData.organizationName || '-' }}/{{ formData.groupName || '-' }}
          </FormItem>
          <FormItem prop="isGroupLeader" key="isGroupLeader" label="是否设为迁移后团队的队长" class="half">
            <RadioGroup v-model="formData.isGroupLeader">
              <Radio label="1">是</Radio>
              <Radio label="0">否</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem prop="newGroupId" key="newGroupId" label="迁移后团队" class="full flex" :rules="$units.formRule.required('请选择')">
            <selectTree type="2" v-model="formData.newGroupId" @change="selectTreeChange" style="width:243px;" ref="selectTree"></selectTree>
            <span class="btn-add" @click="$refs.addTeam.open(formData, detail)">新建团队</span>
          </FormItem>
        </template>
        <template v-if="formData.type == 6">
          <FormItem prop="renewalAllotType" key="renewalAllotType" class="full">
            <template #label>
              续期分配给
              <Poptip
                trigger="hover"
                word-wrap
                width="430"
                :transfer="true"
              >
                <span class="iconfont iconwenhao" style="color:#B1B5B9"></span>
                <div slot="content">
                  <p>若离职人员的全部续期利益转给同一个人，请选择指定代理人；</p>
                  <p>若需要将保单分配给不同的人来做续期服务，请选择分配孤儿单；</p>
                  <p>若不需要改变服务代理人，请选择不分配。</p>
                </div>
              </Poptip>
            </template>
            <RadioGroup v-model="formData.renewalAllotType" clearable>
              <Radio label="1">指定代理人</Radio>
              <Radio v-if="!$units.isXLH()" label="2">分配孤儿单</Radio>
              <Radio label="3">不分配</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem v-if="formData.renewalAllotType == 1" prop="renewalUserType" key="renewalUserType" class="full flex">
            <Select v-model="formData.renewalUserType" clearable filterable transfer @on-change="changeRenewalUserType">
              <Option value="0">上级主管</Option>
              <Option value="1">育成人</Option>
              <Option value="2">推荐人</Option>
              <Option value="3">指定其他人</Option>
            </Select>
            <span v-if="formData.renewalUserType && formData.renewalUserId == ''" class="error">
              <span v-if="formData.renewalUserType == 0">{{ name }}没有上级主管</span>
              <span v-if="formData.renewalUserType == 1">{{ name }}没有育成人</span>
              <span v-if="formData.renewalUserType == 2">{{ name }}没有推荐人</span>
            </span>
            <span v-if="formData.renewalUserType != 3" class="breed-name">{{ formData.renewalUserName }}</span>
            <Select v-if="formData.renewalUserType == 3" v-model="formData.renewalUserId" transfer clearable filterable>
              <Option v-for="(item, i) in orgUserList" :key="i" :value="item.id" :label="item.name" v-if="formData.userId != item.id">
                <i class="dian" :class="{ red: item.workingState == 0, orange: item.isSus == 1 }"></i>
                {{ item.staffNo ? item.name + '-' + item.staffNo : item.name }}
              </Option>
            </Select>
          </FormItem>
          <FormItem prop="policyAllotRecords" label="分配状态" key="policyAllotRecords" v-if="formData.renewalAllotType == 2" class="full flex">
            <Button v-if="formData.policyAllotRecords" type="primary" @click="setPolicyAllotRecords">已分配</Button>
            <Button v-else type="primary" @click="setPolicyAllotRecords">去分配</Button>
          </FormItem>
          <FormItem prop="extendRate" :label-width="140" key="extendRate" class="full flex"
            :rules="$units.formRule.money(false, '续期继承比例需大于等于0')" v-if="formData.renewalAllotType != '3'">
            <template #label>
              续期继承比例
              <Poptip trigger="hover" word-wrap width="300" content="填写后，指定代理人或孤儿单继承的保单续期利益，将按照该比例进行折算。若不填写，则为100%继承续期利益。" :transfer="true">
                <span class="iconfont iconwenhao" style="color:#B1B5B9"></span>
              </Poptip>
            </template>
            <Input v-model="formData.extendRate"></Input>
            <span style="padding-left:4px;">%</span>
          </FormItem>
          <FormItem prop="customerUserType" :label-width="140" key="customerUserType" label="客户转移给" class="full flex">
            <template #label>
              客户转移给
              <Poptip trigger="hover" word-wrap width="300" content="指定后离职人的客户资源将会转移给此人，若不填则不变更。" :transfer="true">
                <span class="iconfont iconwenhao" style="color:#B1B5B9"></span>
              </Poptip>
            </template>
            <Select v-model="formData.customerUserType" clearable filterable transfer @on-change="changeCustomerUserType">
              <Option value="0">上级主管</Option>
              <Option value="1">育成人</Option>
              <Option value="2">推荐人</Option>
              <Option value="3">指定其他人</Option>
              <Option value="999">不分配</Option>
            </Select>
            <span v-if="formData.customerUserType && formData.customerUserId == ''" class="error">
              <span v-if="formData.customerUserType == 0">{{ name }}没有上级主管</span>
              <span v-if="formData.customerUserType == 1">{{ name }}没有育成人</span>
              <span v-if="formData.customerUserType == 2">{{ name }}没有推荐人</span>
            </span>
            <span v-if="formData.customerUserType != 3" class="breed-name">{{ formData.customerUserName }}</span>
            <Select v-if="formData.customerUserType == 3" v-model="formData.customerUserId" transfer clearable filterable>
              <Option v-for="(item, i) in orgUserList" :key="i" :value="item.id" :label="item.name" v-if="formData.userId != item.id">
                <i class="dian" :class="{ red: item.workingState == 0, orange: item.isSus == 1 }"></i>
                {{ item.staffNo ? item.name + '-' + item.staffNo : item.name }}
              </Option>
            </Select>
          </FormItem>

          <FormItem prop="recommendType" :label-width="140" key="recommendType" label="推荐关系转移至" class="full flex">
            <template #label>
              推荐关系转移至
              <Poptip
                trigger="hover"
                word-wrap
                width="300"
                content="举例：A推荐B，B推荐C和D，若B离职并将推荐关系转移至A，则C和D的推荐人将会批量变更为A，若不填则不变更。"
                :transfer="true"
              >
                <span class="iconfont iconwenhao" style="color:#B1B5B9"></span>
              </Poptip>
            </template>
            <Select v-model="formData.recommendType" :disabled='$units.isOkBao() || $units.isOkTX()' clearable transfer filterable @on-change="changeRecommendType">
              <Option value="2">推荐人</Option>
              <Option value="1">指定其他人</Option>
            </Select>
            <span v-if="formData.recommendType && formData.recommendId == ''" class="error">
              <span v-if="formData.recommendType == 2">{{ name }}没有推荐人</span>
            </span>
            <span v-if="formData.recommendType && formData.recommendId" class="breed-name">{{ formData.recommendName }}</span>
            <Select v-if="formData.recommendType == 1" v-model="formData.recommendId" transfer clearable filterable>
              <Option v-for="(item, i) in orgUserList" :key="i" :value="item.id" :label="item.name" v-if="formData.userId != item.id">
                <i class="dian" :class="{ red: item.workingState == 0, orange: item.isSus == 1 }"></i>
                {{ item.staffNo ? item.name + '-' + item.staffNo : item.name }}
              </Option>
            </Select>
          </FormItem>
          <FormItem prop="breedType" :label-width="140" key="breedType" label="育成关系转移至" class="full flex">
            <template #label>
              育成关系转移至
              <Poptip
                trigger="hover"
                word-wrap
                width="300"
                content="举例：A育成B，B育成C和D，若B离职并将育成关系转移至A，则C和D的育成人将会批量变更为A，若不填则不变更。"
                :transfer="true"
              >
                <span class="iconfont iconwenhao" style="color:#B1B5B9"></span>
              </Poptip>
            </template>
            <Select v-model="formData.breedType" :disabled='$units.isOkBao() || $units.isOkTX()' clearable filterable transfer @on-change="changeBreedType">
              <Option value="0">上级主管</Option>
              <Option value="1">育成人</Option>
              <Option value="2">推荐人</Option>
              <Option value="3">指定其他人</Option>
            </Select>
            <span v-if="formData.breedType && formData.breedId == ''" class="error">
              <span v-if="formData.breedType == 0">{{ name }}没有上级主管</span>
              <span v-if="formData.breedType == 1">{{ name }}没有育成人</span>
              <span v-if="formData.breedType == 2">{{ name }}没有推荐人</span>
            </span>
            <span v-if="formData.breedType != 3" class="breed-name">{{ formData.breedName }}</span>
            <Select v-if="formData.breedType == 3" v-model="formData.breedId" transfer clearable filterable>
              <Option v-for="(item, i) in orgUserList" :key="i" :value="item.id" :label="item.name" v-if="formData.userId != item.id">
                <i class="dian" :class="{ red: item.workingState == 0, orange: item.isSus == 1 }"></i>
                {{ item.staffNo ? item.name + '-' + item.staffNo : item.name }}
              </Option>
            </Select>
          </FormItem>
        </template>
        <FormItem prop="effectiveDate" key="effectiveDate" label="生效日期" class="half flex" :rules="$units.formRule.objRequired('请选择')">
          <DatePicker v-model="formData.effectiveDate" format="yyyy-MM-dd" type="date" placeholder="请选择" transfer :options="options"> </DatePicker>
        </FormItem>
        <FormItem label="附件" prop="attachments" key="attachments" class="full">
          <div class="upload-box">
            <uploadNew v-model="formData.attachments" fileType="any" :muti="false" :showFileName="true"> </uploadNew>
          </div>
        </FormItem>
        <FormItem prop="remark" key="remark" label="备注" class="full">
          <Input v-model="formData.remark" placeholder="请输入" type="textarea" :autosize="{ minRows: 3 }" />
        </FormItem>
      </Form>
      <div class="ivu-modal-footer">
        <Button v-if="formData.type == 6 && $units.pointAction('org_2_13')" type="text" @click="$emit('queryRelation',{id:formData.userId})">关系查询</Button>
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="save" :loading="loading">确认</Button>
      </div>
    </Modal>
    <!-- 新增团队 -->
    <add-team ref="addTeam" @success="$refs.selectTree && $refs.selectTree.openChange(true)"></add-team>
    <policyAllotRecordsModal ref="policyAllotRecordsModal" @success="setPolicy"></policyAllotRecordsModal>
  </div>
</template>

<script>
import policyAllotRecordsModal from './policyAllotRecordsModal.vue';
import uploadNew from '@/components/commons/uploadNew';
import selectTree from '@/components/system/selectTree3';
import addTeam from './addTeamModal';
import dayjs from 'dayjs';
export default {
  components: {
    policyAllotRecordsModal,
    selectTree,
    uploadNew,
    addTeam
  },
  props: {},
  data() {
    return {
      visible: false,
      loading: false,
      rankList: [],
      groupList: [],
      orgUserList: [],
      rankName: '',
      name: '',
      staffNo: '',
      selGroupInfo: {},
      baseList:[],
      detail: {},
      formData: {
        effectiveDate: '',
        isGroupLeader: '0',
        newGroupId: '',
        newRankId: '',
        type: '', //1-晋升 2-维持 3-迁移 4-降级 5-停职 6-离职  7-复职
        isChange: '0', //是否迁移
        groupLeaderType: '1', //1-迁移全部团员  2-变更团队长
        renewalAllotType: '3'
      },
      salesPolicysList: [], //业务员保单
      options: {
        disabledDate: this.disabledDate // 这是一个方法
      }
    };
  },
  computed: {
    title() {
      if (this.formData.type == 1) {
        return '晋升';
      } else if (this.formData.type == 2) {
        return '维持';
      } else if (this.formData.type == 3) {
        return '迁移';
      } else if (this.formData.type == 4) {
        return '降级';
      } else if (this.formData.type == 5) {
        return '停职';
      } else if (this.formData.type == 6) {
        return '离职';
      } else if (this.formData.type == 7) {
        return '复职';
      }
    }
  },
  methods: {
     // 获取基本法列表
     getBaseList() {
      return this.$http({
        url: '/buz/baseMethod/list',
        type: 'post',
        data: {
          pageNo: 1,
          pageSize: 999
        }
      }).then(res => {
        this.baseList = res.data
      });
    },
    changeVisible(val){
      console.log(val)
      if(!val){
        this.$emit('success');
      }
    },
    getSalesPolicys() {
      this.$http({
        url: '/buz/policy/listSalesmanPolicys',
        type: 'POST',
        data: {
          salesmanId: this.formData.userId,
          pageNo: 1,
          pageSize: 9999
        }
      }).then(res => {
        this.salesPolicysList = res.data;
      });
    },
    disabledDate(date) {
      if (this.formData.type == '1' || this.formData.type == '4') {
        // 晋升、降级弹窗中----生效日期限制为只能选择每个月1号
        return dayjs(date).format('DD') != '01';
      } else if (this.formData.type == '6') {
        return false;
      } else {
        return dayjs(date).isBefore(dayjs()) && dayjs(date).format('YYYY-MM-DD') !== dayjs().format('YYYY-MM-DD');
      }
    },
    setPolicy(policyAllotRecords) {
      this.$set(this.formData, 'policyAllotRecords', policyAllotRecords);
    },
    //分配孤儿单
    setPolicyAllotRecords() {
      this.$refs.policyAllotRecordsModal.open(this.detail, this.formData.policyAllotRecords);
    },
    changeCustomerUserType(val) {
      if (val == 0 && this.detail.groupLeaderId) {
        //育成关系转移至上级主管
        this.formData.customerUserId = this.detail.groupLeaderId;
      } else if (val == 1 && this.detail.breedId) {
        //育成关系转移至育成人
        this.formData.customerUserId = this.detail.breedId;
      } else if (val == 2 && this.detail.userId) {
        //育成关系转移至推荐人
        this.formData.customerUserId = this.detail.userId;
      } else if (val == 3) {
        //育成关系转移至指定人
        this.formData.customerUserId = '';
        this.formData.customerUserName = '';
      } else {
        this.formData.customerUserId = '';
        this.formData.customerUserName = '';
      }
      if (this.formData.customerUserId) {
        let breed = this.orgUserList.find(i => i.id == this.formData.customerUserId);
        this.formData.customerUserName = breed.staffNo + '/' + breed.name;
      }
    },
    changeRenewalUserType(val) {
      if (val == 0 && this.detail.groupLeaderId) {
        //育成关系转移至上级主管
        this.formData.renewalUserId = this.detail.groupLeaderId;
      } else if (val == 1 && this.detail.breedId) {
        //育成关系转移至育成人
        this.formData.renewalUserId = this.detail.breedId;
      } else if (val == 2 && this.detail.userId) {
        //育成关系转移至推荐人
        this.formData.renewalUserId = this.detail.userId;
      } else if (val == 3) {
        //育成关系转移至指定人
        this.formData.renewalUserId = '';
        this.formData.renewalUserName = '';
      } else {
        this.formData.renewalUserId = '';
        this.formData.renewalUserName = '';
      }
      if (this.formData.renewalUserId) {
        let breed = this.orgUserList.find(i => i.id == this.formData.renewalUserId);
        this.formData.renewalUserName = breed.staffNo + '/' + breed.name;
      }
    },
    changeRecommendType(val) {
      if (val == 2 && this.detail.userId) {
        //育成关系转移至推荐人
        this.formData.recommendId = this.detail.userId;
      } else {
        this.formData.recommendId = '';
        this.formData.recommendName = '';
      }
      if (this.formData.recommendId) {
        let recommen = this.orgUserList.find(i => i.id == this.formData.recommendId);
        this.formData.recommendName = recommen.staffNo + '/' + recommen.name;
      }
    },
    changeBreedType(val) {
      if (val == 0 && this.detail.groupLeaderId) {
        //育成关系转移至上级主管
        this.formData.breedId = this.detail.groupLeaderId;
      } else if (val == 1 && this.detail.breedId) {
        //育成关系转移至育成人
        this.formData.breedId = this.detail.breedId;
      } else if (val == 2 && this.detail.userId) {
        //育成关系转移至推荐人
        this.formData.breedId = this.detail.userId;
      } else if (val == 3) {
        //育成关系转移至指定人
        this.formData.breedId = '';
        this.formData.breedName = '';
      } else {
        this.formData.breedId = '';
        this.formData.breedName = '';
      }
      if (this.formData.breedId) {
        let breed = this.orgUserList.find(i => i.id == this.formData.breedId);
        this.formData.breedName = breed.staffNo + '/' + breed.name;
      }
    },
    changeGroup(val) {
      console.log(val);
      if (val == 1) {
        this.formData.isGroupLeader = '0';
      }
      this.formData.newGroupId = '';
    },
    // 获取团队列表
    getGroupList() {
      this.$http({
        url: '/buz/organizationGroup/getSubGroup',
        type: 'get',
        data: {
          organizationId: JSON.parse(localStorage.userInfo).organId
        }
      }).then(res => {
        this.groupList = res.data;
      });
    },
    save() {
      this.$refs.form.validate().then(async isok => {
        if (!isok) {
          return;
        }
        if (this.formData.type == 3 && this.formData.isGroupLeader == 1 && this.selGroupInfo.groupLeaderId) {
          //如果设置为新团队的团队长，需判断目标团队是否已有团队长，如果已有团队长弹窗提示，没有的话不弹窗
          await this.$notice.inquiry(`拟迁移的团队已有团队长${this.selGroupInfo.groupStaffNo}/${this.selGroupInfo.groupLeaderName}，请确认是否替换？`);
        }
        const formData = JSON.parse(JSON.stringify(this.formData));
        if (this.formData.renewalAllotType == 2 && !this.formData.policyAllotRecords && this.salesPolicysList.length != 0) {
          return this.$notice.error('您还没有分配孤儿单');
        }
        if (formData.customerUserType == '999') delete formData.customerUserType;
        this.$http({
          url: '/buz/userBase/change',
          type: 'POST',
          data: formData,
          apiPermissionCode: 'org_2_6'
        }).then(res => {
          this.visible = false;
          this.$notice.success('操作成功');
        });
      });
    },

    // 选中机构/团队
    selectTreeChange(data) {
      console.log(data);
      if (data.id) {
        if (data.nodeType == 1) {
          //机构
          this.formData.newGroupId = '';
          this.selGroupInfo = {};
          this.$notice.error('请选择团队');
        } else if (data.nodeType == 2) {
          //团队
          this.formData.newGroupId = data.id;
          this.selGroupInfo = data;
        } else {
          this.formData.newGroupId = '';
          this.selGroupInfo = {};
        }
      } else {
        this.formData.newGroupId = '';
        this.selGroupInfo = {};
      }
    },
    open(data) {
      data = JSON.parse(JSON.stringify(data));
      console.log('data=-==', data);
      this.selGroupInfo = {};
      this.formData = {
        effectiveDate: '',
        isGroupLeader: '0',
        newGroupId: '',
        newRankId: '',
        type: '', //1-晋升 2-维持 3-迁移 4-降级 5-停职 6-离职  7-复职
        isChange: '0', //是否迁移
        groupLeaderType: '1', //1-迁移全部团员  2-变更团队长
        renewalAllotType: '3'
      };
      this.visible = true;
      this.$refs.form && this.$refs.form.resetFields();
      this.detail = data;
      this.rankName = data.rankName;
      this.name = data.name;
      this.staffNo = data.staffNo; //
      this.formData.userId = data.id; //用户id
      this.formData.oldRankId = data.rankId; //原职级id
      this.formData.organizationId = data.organizationId; //原机构id
      this.formData.oldGroupId = data.groupId; //团队id
      this.formData.type = data.type; //更改类型
      this.formData.groupLeader = data.isGroupLeader == '1' || data.isGroupLeader == true ? '1' : '0'; //是否是团队长
      this.formData.organizationName = data.organizationName; //原机构名称
      this.formData.groupName = data.groupName; //原团队名称
      this.getRankList();
      this.getGroupList();
      this.getOrgUserList();
      this.getSalesPolicys();
      this.getBaseList()
      this.$nextTick(() => {
        this.$refs.selectTree && this.$refs.selectTree.openChange();
      });
    },
    // 机构内部业务员
    getOrgUserList() {
      console.log(this.formData);
      this.$http({
        url: '/buz/userBase/queryUserByEntryConfig',
        type: 'get',
        data: {
          orgId: this.$route.query.organizationId || this.formData.organizationId
        }
      }).then(res => {
        this.orgUserList = res.data;
      });
    },
    //获取职级
    getRankList() {
      this.$http({
        url: '/buz/baseRank/read/all',
        type: 'POST',
        data: {}
      }).then(res => {
        this.rankList = res.data;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.dian {
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #35bf3f;
  border-radius: 50%;
  margin-right: 4px;
  vertical-align: top;
  transform: translateY(7px);

  &.red {
    background: #e3461f;
  }
}

.my-modal {
  .error {
    color: #e3461f;
    margin-left: 10px;
  }

  .breed-name {
    margin-left: 10px;
  }

  /deep/.ivu-select {
    flex: 0 0 41.5%;
  }

  .flex {
    /deep/.ivu-form-item-content {
      display: flex;
    }

    .ivu-input-wrapper {
      flex: 0 0 41.5%;
    }
  }

  .btn-add {
    color: #236dff;
    cursor: pointer;
    margin-left: 10px;
  }

  .notice {
    margin-left: 10px;
    flex: 0 0 57%;
    width: 57%;
    display: inline-block;

    em {
      color: #e3461f;
      margin-right: 2px;
    }
  }

  .info-text {
    font-size: 12px;
    color: #a8adb7;
    line-height: 1.5;
    padding-top: 7px;
  }

  .password-icon {
    position: absolute;
    transform: translateX(-30px);
  }

  img.password-icon {
    width: 16px;
    top: 8px;
  }

  .ivu-icon-ios-eye {
    font-size: 18px;
    color: #a8adb7;
    top: 7px;
  }
}
.half {
  width: 50%;
}
</style>
